<template>
  <page :title="$t('mass_mail')" size="is-desktop">
    <form @submit.prevent="handleSubmit" v-if="form">
      <div class="columns">
        <div class="column is-4">
          <div class="box">
            <b-field label="Mail type">
              <b-select placeholder="Choose a type" v-model="type" expanded>
                <option value="html">Html</option>
                <option value="text">Text</option>
              </b-select>
            </b-field>
          </div>
        </div>

        <div class="column is-8">
          <div class="box">
            <b-field label="Email" message ="Mailgun email list email">
              <b-select placeholder="Choose a type" v-model="email" expanded>
                <option value="all_users@mail.wplus.world">All Users</option>
                <option value="active_users@mail.wplus.world">Active Users</option>
                <option value="purchased_users@mail.wplus.world">Purchased Users</option>
                <option value="inactive_users@mail.wplus.world">Inactive Users</option>
                <option value="wplus.world@mail.wplus.world">Test Users</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="Subject">
              <b-input placeholder="Subject" v-model="subject"></b-input>
            </b-field>
          </div>

          <div class="box">
            <b-field v-if="type == 'text'" label="Text ">
              <b-field >
                <b-input maxlength="200" v-model="text" type="textarea"></b-input>
              </b-field>
            </b-field>

            <b-field
              v-else-if="type == 'html'"
              label="HTML upload"
              message="File must be html"
            >
              <file-picker
                accept="html"
                @picked="pickedHtml"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload file</button>
                <hr />
              </file-picker>
            </b-field>

            <b-field v-else label="Select an ADS type first"></b-field>
          </div>
        </div>
      </div>

      <hr />
      <div class="is-pulled-right">
        <router-link to="/ads" class="button" :disabled="form.processing">Cancel</router-link>

        <button class="button is-primary ml-2" :class="{ 'is-loading': form.processing }">
          <b-icon icon="email-send"></b-icon>
          <span>Send Email</span>
        </button>
      </div>
    </form>
  </page>
</template>

<script>

import FilePicker from "../../components/FilePicker";

export default {
  components: {
    FilePicker
  },

  data() {
    return {
      type: 'html',
      subject: null,
      email: 'all_users@mail.wplus.world',
      text: null,
      form: new window.FormData(),
    };
  },

  watch: {
    image() {
      this.form.path = this.image.path;
    },
    screenShot() {
      this.form.screenshot_path = this.screenShot.path;
    }
  },

  methods: {
    handleSubmit() {
      this.form.append(
        'subject',
        this.subject
      );

      this.form.append(
        'email',
        this.email
      );

      this.form.append(
        'type',
        this.type
      );

      this.$http
        .post(`/admin/api/send-email`, this.form)
        .then(response => {
            this.$buefy.toast.open({
              type: "is-success",
              message: "Successfully saved."
            })

            if (response) {
              console.log(response);
            }

            this.$router.push("/dashboard");
        });
    },

    pickedHtml(file) {
      this.form.append(
        'html',
        file,
        this.fileName ? this.fileName : undefined
      );
    }
  }
};
</script>
